export default __webpack_public_path__ + "static/media/Diginoor, Cine-NFT Marketplace bags $1 M in Seed round.42570941.jpeg";